<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('supplierOutgoingVendorRequest.mracitlrim')"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-6">
          <div
            class="card pointer h-100 mb-0"
            :class="{'bg-primary':activeTab==='requests' }"
            @click.prevent="activeTab='requests'"
          >
            <div class="card-body">
              <h4>{{ $t('supplierOutgoingVendorRequest.mracitlrim') }}</h4>
              <p>{{ $t('supplierOutgoingVendorRequest.tdarkDyrlndirmFormalarnaGndrilnMracitlr') }}</p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div
            class="card pointer h-100 mb-0"
            :class="{'bg-primary':activeTab==='customers' }"
            @click.prevent="activeTab='customers'"
          >
            <div class="card-body">
              <h4>{{ $t('supplierOutgoingVendorRequest.mtrilrim') }}</h4>
              <p>{{ $t('supplierOutgoingVendorRequest.tsdiqlnmiTdarkSiyahsndaOlduumIrktlr') }}</p>
            </div>
          </div>
        </div>
      </div>


      <div
        v-show="activeTab==='requests'"
        class="mt-3"
      >
        <div class="card">
          <div class="card-body">
            <p>
              {{ $t('supplierOutgoingVendorRequest.aadaSizinEtibarlTdarksOlmaqIstdiyinizTkilatlarnSiy') }}
            </p>
            <p>
              {{ $t('supplierOutgoingVendorRequest.1SizHrHansBirSektorunIrisinDaxilOlubHminSektorunKn') }}
            </p>
            <p>
              {{ $t('supplierOutgoingVendorRequest.2HrHansBirTkilatBirBaaSizTdarkFormasnnLinkiniGndri') }}
            </p>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                v-if="profile==='SUPPLIER'"
                class="col-md-8"
              >
                <select
                  v-model.number="requestSectorFilter"
                  class="form-control"
                >
                  <option value="0">
                    {{ $t('vendorManagementPurchasesReports.btnFaliyytSahlri') }}
                  </option>
                  <option
                    v-for="s in requestSectorList"
                    :value="s.id"
                  >
                    <div v-if="$i18n.locale === 'az'">
                      {{ s.name }}
                    </div>
                    <div v-else-if="$i18n.locale === 'en'">
                      {{ s.nameEn }}
                    </div>
                    <div v-else-if="$i18n.locale === 'ru'">
                      {{ s.nameRu }}
                    </div>
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <select
                  v-model="statusFilter"
                  class="form-control"
                >
                  <option value="ALL">
                    {{ $t('vendorManagementPurchasesReports.hams') }}
                  </option>
                  <option value="MESSAGE">
                    {{ $t('supplierOutgoingVendorRequest.oxunmamMesaj') }}
                  </option>
                  <option value="DRAFT">
                    {{ $t('myRequest.qaralama') }}
                  </option>
                  <option value="READY">
                    {{ $t('supplierOutgoingVendorRequest.hazrdr') }}
                  </option>
                  <option value="APPROVED">
                    {{ $t('supplierOutgoingVendorRequest.tsdiqlnmi') }}
                  </option>
                  <option value="WAITING">
                    {{ $t('supplierOutgoingVendorRequest.gzlmd') }}
                  </option>
                  <option value="RETURNED">
                    {{ $t('supplierOutgoingVendorRequest.geriQaytarlb') }}
                  </option>
                  <option value="REJECTED">
                    {{ $t('supplierOutgoingVendorRequest.lvEdilib') }}
                  </option>
                </select>
              </div>
            </div>
          </div>


          <div
            v-if="filteredRequests.length <1"
            class="card-body"
          >
            <div
              v-if="statusFilter==='MESSAGE'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.oxunamamMesajnzOlanMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="statusFilter==='WAITING'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.sizinGzlmdOlanMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="statusFilter==='DRAFT'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.sizinQaralamaStatusundaMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="statusFilter==='APPROVED'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.sizinTsdiqlnmiMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="statusFilter==='RETURNED'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.sizinDzliNGeriGndrilmiMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="statusFilter==='REJECTED'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.sizinLvEdilmiMracitinizYoxdur') }}
            </div>
            <div
              v-else
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.uyunMracitTaplmad') }}
            </div>
          </div>


          <template v-for="r in filteredRequests">
            <hr class="my-0 py-0">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-10">
                  <h4><span class="h4">#{{ r.id }}</span> {{ r.companyForm.name }}</h4>
                  <code>[{{ r.companyForm.company.name }} {{ getCompanyFormat(r.companyForm.company.format) }}]</code>
                </div>
                <div class="col-md-2 text-right">
                  <CompanyFormRequestStatus :status="r.status" />

                  <span
                    v-if="r.unreadMessageCountSupplier>0"
                    class="badge badge-danger blink"
                  >
                    {{
                      $t('supplierOutgoingVendorRequest.runreadmessagecountsupplierYeniMesaj', {count: r.unreadMessageCountSupplier})
                    }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span>{{ $t('supplierOutgoingVendorRequest.mllif') }} </span> <span class="text-dark">{{
                    r.user.name
                  }} {{ r.user.surname }}</span> <br>
                  <span>{{ $t('supplierOutgoingVendorRequest.doldurulmaVaxt') }} </span> <span
                    class="text-dark"
                  >{{ r.createTime }}</span> <br>
                </div>
                <div class="col-md-6">
                  <span>{{ $t('supplierOutgoingVendorRequest.sonDyiiklikVaxt') }} </span> <span
                    class="text-dark"
                  >{{ r.lastUpdateTime }}</span> <br>
                  <span>{{ $t('supplierOutgoingVendorRequest.gndrilmVaxt') }} </span> <span
                    class="text-dark"
                  >{{ r.sendTime || '-' }}</span> <br>
                </div>
                <div
                  v-if="['RETURNED','REJECTED'].indexOf(r.status)>-1"
                  class="col-md-12"
                >
                  <div class="text-danger">
                    <span>{{ $t('request.sbb2') }} </span> {{ r.reason }}
                  </div>
                </div>

                <div class="col-md-9">
                  <div v-if="profile==='SUPPLIER'">
                    <span>{{ $t('supplierOutgoingVendorRequest.faliyytSahlri') }} </span>
                    <div
                      v-for="s in getRequestSectorList(r)"
                      class="text-dark"
                    >
                      -
                      <div v-if="$i18n.locale === 'az'">
                        {{ s.sector.name }}
                      </div>
                      <div v-else-if="$i18n.locale === 'en'">
                        {{ s.sector.nameEn }}
                      </div>
                      <div v-else-if="$i18n.locale === 'ru'">
                        {{ s.sector.nameRu }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 text-right mt-auto">
                  <button
                    class="btn btn-sm btn-light-primary mr-2"
                    @click="showRequestDetails(r.id)"
                  >
                    {{ $t('supplierOutgoingVendorRequest.trafl') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div
        v-show="activeTab==='customers'"
        class="mt-3"
      >
        <div
          v-if="deletedVendors.length>0"
          class="card"
        >
          <div class="card-header">
            <div class="row">
              <div class="col-md-12">
                <h5>Bu siyahıda sizi öz təsdiqli tədarükçülər siyahısından çıxartmış şirkətləri və bunun üçün gətirdikləri səbəbləri görəcəksiz</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              v-for="(vendor, index) in deletedVendors"
              :key="index"
              class="vendor-card mb-3 p-3 border rounded"
            >
              <h5>{{ vendor.company.name }} : VÖEN {{ vendor.company.taxId }} </h5>
              <p><strong>Səbəb:</strong> {{ vendor.reason }}</p>
              <p><strong>Silinmə vaxtı:</strong> {{ new Date(vendor.logTime).toLocaleString() }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="blacklisted.length>0"
          class="card"
        >
          <div class="card-header">
            <div class="row">
              <div class="col-md-12">
                <h5>Bu siyahıda şirkətinizin hansl şirkətlərin qara siyahısında olduğunu və səbəbini görə bilərsiz.</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              v-for="(vendor, index) in blacklisted"
              :key="index"
              class="vendor-card mb-3 p-3 border rounded"
            >
              <h5>{{ vendor.company.name }} : VÖEN {{ vendor.company.taxId }}</h5>
              <p><strong>Səbəb:</strong> {{ vendor.reason }}</p>
              <p><strong>Silinmə vaxtı:</strong> {{ new Date(vendor.logTime).toLocaleString() }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="profile==='SUPPLIER'"
          class="card"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <select
                  v-model.number="customerSectorFilter"
                  class="form-control"
                >
                  <option value="0">
                    {{ $t('vendorManagementPurchasesReports.btnFaliyytSahlri') }}
                  </option>
                  <option
                    v-for="s in customerSectorList"
                    :value="s.id"
                  >
                    {{ s.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-4" />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-12">
                <p>{{ $t('supplierOutgoingVendorRequest.sizBuSiyahdaGndrdiyinizTdarkDyrlndirmFormalarnTsdi') }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="filteredCustomers.length<1"
            class="card-body"
          >
            {{ $t('supplierOutgoingVendorRequest.irktinizHeBirIrktTrfindnTsdiqlnmyib') }}
          </div>

          <div
            v-for="v in filteredCustomers"
            class="list-group-item"
          >
            <div class="row">
              <div
                class="col-md-4 mb-3"
                @click="openCompanyPopup({company:v.company, profile: 'PROCUREMENT'})"
              >
                <strong>{{ v.company.name }} {{ getCompanyFormat(v.company.format) }}</strong>
                <br>
                {{ $t('supplierOutgoingVendorRequest.ven') }} <em>{{ v.company.taxId }}</em>
              </div>
              <div class="col-md-8 mb-3">
                <div v-for="s in v.sectors">
                  - {{ s.sector.name }}
                  <a
                    v-if="s.companyFormRequest"
                    href="#"
                    @click.prevent="showRequestDetails(s.companyFormRequest?.id)"
                  >
                    {{ $t('supplierOutgoingVendorRequest.mracit', {id: s.companyFormRequest?.id}) }}
                  </a>
                  <p v-else>
                    Manual əlavə edilmisiz
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                {{
                  $t('supplierOutgoingVendorRequest.newDatevlogtimeMomentddMmmYyyyTarixindTsdiqlnmidir', {moment: getMoment(v.logTime)})
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <b-modal
      id="modal-vendor-request"
      size="xl"
      centered
      :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
      scrollable
      class="theme-modal"
      :hide-footer="true"
      @close="getMyRequests"
    >
      <VendorRequestDetails
        v-if="activeRequestId>0"
        :active-request-id="activeRequestId"
        @companyPopup="openCompanyPopup($event)"
      />
    </b-modal>


    <b-modal
      v-if="openCompanyRatingStatisticPopup>0"
      id="modal-company-rate-statists"
      centered
      :title="`${getProfileName(openCompanyRatingStatisticPopupProfile)} profili`"
      ok-only
      ok-title="bağla"
      class="theme-modal"
    >
      <CompanyRateStatistics
        :company-id="openCompanyRatingStatisticPopup"
        :profile-type="openCompanyRatingStatisticPopupProfile"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import {getCustomerList, getFormOutgoingRequests} from "@/repositories/VendorManagementRepository";
import VendorRequestDetails from "@/pages/scc/vendorManagement/VendorRequestDetails.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";
import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";
import moment from "moment/moment";

export default {
  components: {CompanyRateStatistics, CompanyFormRequestStatus, VendorRequestDetails},
  data() {
    return {
      mediaBase: mediaBase,
      requests: [],
      status: 'active',
      requestStatistics: {},
      activeRequestId: 0,
      statusFilter: 'ALL',
      requestSectorFilter: 0,
      customerSectorFilter: 0,
      deletedVendors : [],
      blacklisted:[],
      openCompanyRatingStatisticPopup: 0,
      openCompanyRatingStatisticPopupProfile: '',

      customers: [],
      activeTab: 'requests'
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
    requestSectorList() {

      let map = {};

      this.requests.forEach(r => {
        this.getRequestSectorList(r).forEach(s => {
          map[s.sector.id] = s.sector;
        })
      })

      return Object.values(map);
    },

    customerSectorList() {

      let map = {};
      this.customers.forEach(c => {
        c.sectors.forEach(s => {
          map[s.sector.id] = s.sector;
        })
      })

      return Object.values(map);
    },
    filteredRequests() {

      let requests = [];

      if (this.statusFilter === 'ALL') {
        requests = this.requests;
      } else if (this.statusFilter === 'MESSAGE') {
        requests = this.requests.filter(r => r.unreadMessageCountSupplier > 0);
      } else {
        requests = this.requests.filter(r => r.status === this.statusFilter);
      }

      if (this.requestSectorFilter > 0) {
        requests = requests.filter(r => r.sectors.split(',').indexOf(this.requestSectorFilter + "") > -1)
      }

      return requests;
    },

    filteredCustomers() {

      let customers = this.customers;

      if (this.customerSectorFilter > 0) {
        customers = customers.filter(c => c.sectors.filter(s => s.sector.id === this.customerSectorFilter).length > 0)
      }

      return customers;
    }

  },
  watch: {

    "$route"() {
      this.activeRequestId = this.$route.query['request'] || 0;
      this.showRequestDetails(this.activeRequestId);
    },

    status() {
      this.getMyRequests();
    },

    activeRequestId(newVal) {
      if (newVal > 0) {
        this.$bvModal.hide('modal-vendor-request')
      }
    }
  },
  mounted() {
    this.getMyRequests();

    this.activeRequestId = this.$route.query['request'] || 0;

    if (this.activeRequestId > 0) {
      this.showRequestDetails(this.activeRequestId);
    }

    this.getCustomerList();
  },
  methods: {

    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getMyRequests() {
      getFormOutgoingRequests(this.token).then(data => {
        this.requests = data;
      })
    },

    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },

    getRequestSectorList(r) {
      if (!r.sectors) {
        return [];
      }
      let selectedIds = r.sectors.split(',');

      let filter = r.companyForm.sectors.filter(s => selectedIds.indexOf(s.sector.id + '') > -1);
      return filter;

    },


    getCustomerList() {

      getCustomerList(this.token).then((list) => {
        this.customers = list.customers;
        this.deletedVendors = list.deletedVendors;
        this.blacklisted = list.blacklisted;
      });

    },


    openCompanyPopup({company, profile}) {
      this.$bvModal.show('modal-company-rate-statists');
      this.openCompanyRatingStatisticPopup = company.id;
      this.openCompanyRatingStatisticPopupProfile = profile;
    }

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
